import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgComponentOutlet } from '@angular/common';
import { LoadingToastComponent } from './loading-toast.component';

@Component({
  selector: 'lib-loading-toast-outlet',
  template: `
    <ng-container *ngComponentOutlet="LoadingToastComponent"></ng-container>
  `,
  styles: [],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgComponentOutlet],
})
export class LoadingToastOutletComponent {
  protected readonly LoadingToastComponent = LoadingToastComponent;
}
